import { WORKFLOW_GUIDE_CONCEPT_SECTIONS } from '@chatsdet/content/workflow-guide';

/** Pull a shared workflow-guide section's body by slug (single source of truth). */
const guideSection = (slug: string): string =>
  WORKFLOW_GUIDE_CONCEPT_SECTIONS.find((s) => s.slug === slug)?.content.trimEnd() ?? '';

export const renderBrowserTestingCurrentWorkflowAuthoring =
  (): string => `## Creating Tests from Browser Exploration

After exploring an app via \`canary session\`, you can persist what you discovered as a reusable test workflow.

### Explore → Author → Create flow

1. **Explore**: Use \`canary session\` to navigate, snapshot, and interact with the app
2. **Author**: Construct workflow JSON with nodes and playbook steps based on what was observed
3. **Create**: Pipe JSON to \`canary workflow create\`
4. **Verify**: Check with \`canary workflow get <id>\`

### What a strong action node looks like

The altitude guidance below is the shared source of truth (identical to \`canary workflow guide action-nodes\` and the Flow Designer):

${guideSection('action-nodes')}

### Authoring nodes in Cofactor JSON

- Node types: \`login\` (authentication), \`navigate\` (go to URL), \`action\` (interact with elements), \`assertion\` (verify standalone page state), \`end\` (terminal node)
- Every action node **must** have a \`customActionTitle\` — a short (3-8 word) title naming the step's goal
- **Prefer inline assertions** on action nodes over separate assertion nodes. Add \`inlineAssertions\` to verify the outcome right after the action completes. Use separate \`assertion\` nodes only for standalone page-level checks that don't belong to an action
- Inline assertion format: \`{ "condition": "...", "severity": "fatal" | "fail" | "warn" }\` (fatal = halt the test now, fail = mark run failed but continue, warn = record only). **Do not author an \`id\` field** — the server stamps a UUID on persist. Hand-rolled UUIDs (especially placeholders like \`a1b2c3d4-...\`) are rejected and replaced.

`;
